import { MessageRow as SharedMessageRow } from '@/features/dryad';
import { ConditionType } from './condition-types';
import { ConditionTypeSelect } from './condition-type-select';
import { messageChannelFromName } from './message-filter-condition';

type MessageRowProps = {
  /** The leaf node's id, supplied by the group to every registered view. */
  id: string;
};

/**
 * The people surface's binding of the shared message row. The channel
 * derivation is this surface's, because the event name it reads is the
 * people-search wire's picker grammar.
 */
export function MessageRow({ id }: MessageRowProps) {
  return (
    <SharedMessageRow
      id={id}
      conditionType={ConditionType.Message}
      typeSelect={<ConditionTypeSelect nodeId={id} currentType={ConditionType.Message} />}
      channelFromName={messageChannelFromName}
    />
  );
}
